import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ConnectionStatus = 'connected' | 'disconnected' | 'reconnecting' | 'error';

interface ConnectionState {
  status: ConnectionStatus;
  isConnected: boolean;
  lastPing: number | null;
  error: string | null;
}

const initialState: ConnectionState = {
  status: 'disconnected',
  isConnected: false,
  lastPing: null,
  error: null
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<ConnectionStatus>) => {
      state.status = action.payload;
      state.isConnected = action.payload === 'connected';
      if (action.payload === 'connected') {
        state.error = null;
      }
    },
    setLastPing: (state, action: PayloadAction<number>) => {
      state.lastPing = action.payload;
    },
    setConnectionError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.status = 'error';
    }
  }
});

export const { setConnectionStatus, setLastPing, setConnectionError } = connectionSlice.actions;
export default connectionSlice.reducer;